import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDYbvhhgFlfKlEnj45xS5tOeGSsMKCdFFg",
    authDomain: "discord-clone-7cd1f.firebaseapp.com",
    projectId: "discord-clone-7cd1f",
    storageBucket: "discord-clone-7cd1f.appspot.com",
    messagingSenderId: "980048111927",
    appId: "1:980048111927:web:a3c73475546759985e52b2",
    measurementId: "G-DPY8F8FGFZ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;